import { type FC, type RefObject } from 'react';
import { Box, InputAdornment, useTheme } from '@mui/material';
import { type SxProps } from '@mui/system';

import { searchIcon } from '@/assets';
import { BaseInput } from './BaseInput';

type Props = {
  label: string;
  name: string;
  error: boolean;
  helperText: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  blur?: (value: string) => void;
  value: string | number;
  sx?: SxProps;
  type?: string;
  valueForNumberChanging?: number;
  inputRef?: RefObject<HTMLInputElement>;
  search?: boolean;
  endAdornment?: React.ReactNode;
  placeholder?: string;
  disabled?: boolean;
  autoHeight?: boolean;
  updated?: boolean;
  compact?: boolean;
  startAdornment?: React.ReactNode;
  fullWidth?: boolean;
};
export const MobileInput: FC<Props> = ({
  sx = {},
  search,
  endAdornment,
  startAdornment,
  autoHeight,
  updated,
  fullWidth,
  onClick,
  ...props
}) => {
  const theme = useTheme();
  const { direction } = useTheme();
  const isRtl = direction === 'rtl';
  return (
    <BaseInput
      fullWidth={fullWidth}
      sx={{
        borderRadius: theme.shape.borderRadius,
        width: '100%',
        height: autoHeight ? 'auto' : theme.spacing(5), // 40px
        '& .MuiOutlinedInput-root': {
          '& > fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: updated
              ? theme.palette.success.main
              : theme.palette.divider,
            // borderWidth: 1,
          },
        },
        ...sx,
      }}
      sxLabel={{
        color: theme.palette.text.primary,
      }}
      isTextDirectionRtl={isRtl}
      endAdornment={endAdornment}
      autoHeight={autoHeight}
      onClick={onClick}
      startAdornment={
        search ? (
          <InputAdornment position='start'>
            <Box component='img' src={searchIcon} />
          </InputAdornment>
        ) : startAdornment ? (
          startAdornment
        ) : (
          <></>
        )
      }
      {...props}
    />
  );
};
